import React, { useState } from "react";
import { SectionHeader } from "./ui/SectionHeader";
import { faqs } from "../data/content";
import { Plus, Minus } from "lucide-react";
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-10 md:py-16 border-t border-gray-100" style={{
    paddingTop: "11px"
  }} data-id="element-109" data-mp="1cgb7favmyce3">
      <div className="container mx-auto px-4 md:px-6 max-w-[1120px]" data-id="element-110" data-mp="2a05u27m6lude">
        <SectionHeader badge="PREGUNTAS" theme="light" title={<>PREGUNTAS <span className="text-[#F3AD00]" data-id="element-112" data-mp="203jb5odf1de0">FRECUENTES</span></>} className="mb-6 md:mb-10" data-id="element-111" data-mp="253oy4r8qqbpr" />

        <div className="max-w-3xl mx-auto flex flex-col gap-2 md:gap-3" data-id="element-113" data-mp="1v5hj4dy0i3qe">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="bg-white border border-[#E5E7EB] rounded-[10px] md:rounded-[12px] overflow-hidden transition-all duration-200 shadow-sm" data-id="element-114" data-mp="omt1fv9sa3fn" data-mpi={index}>
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-4 md:p-5 text-left focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-115" data-mp="1korrtgyfbuhi">
                  <span className="font-[800] text-[14px] md:text-[16px] text-[#07152D] pr-6 md:pr-8 leading-tight" data-id="element-116" data-mp="1aqc1vhb4ur9l">{faq.question}</span>
                  <div className="flex-shrink-0 w-6 h-6 md:w-8 md:h-8 flex items-center justify-center rounded-full bg-[#F5F7F9] text-[#142FA8]" data-id="element-117" data-mp="1fmsrkfxzddos">
                    {isOpen ? <Minus className="w-4 h-4" data-id="element-118" data-mp="16o7akp85q6q4" /> : <Plus className="w-4 h-4" data-id="element-119" data-mp="16pid6lpv98fn" />}
                  </div>
                </button>
                
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`} data-id="element-120" data-mp="s0vxuk08ogof">
                  <div className="p-4 md:p-5 pt-0 text-gray-600 leading-[1.5] border-t border-gray-50 mt-1 text-[13px] md:text-[15px]" data-id="element-121" data-mp="ixuxz11yvlt7">
                    {faq.answer}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}